import localFont from 'next/font/local';

export const SundryCondensedFont = localFont({
  src: [{ path: './sundry-condensed-heavy.otf', weight: '700' }],
});

export const SundryCondensed = SundryCondensedFont.style.fontFamily;
